import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Container, Input } from "reactstrap";
import { BsCalendar2Date } from 'react-icons/bs';
import CreatableSelect from "react-select/creatable";
import { FaPlusCircle, FaSearch } from "react-icons/fa";
import { Button, Col, Form, Row } from "react-bootstrap";
// ต้อง import และ register scales ที่จำเป็น
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";

// register ให้ Chart.js รู้จัก scale และ element ต่าง ๆ
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

import { Bar } from "react-chartjs-2";
import WorkflowPerformanceViewModel from "./WorkflowPerformance.viewmodel";

const customStyles = {
    multiValueRemove: (base, state) => {
        return state.data.isFixed
            ? { ...base, display: 'none', zIndex: 'auto' }
            : base;
    },
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

type SingleChartData = {
    header: string
    labels: string[];
    datasets: {
        label: string;
        data: number[];
        backgroundColor: string;
        borderColor: string;
        borderWidth: number;
    }[];
};


export default function WorkflowPerformanceView() {
    const {
        companyMaster,
        selectedCompany
    } = WorkflowPerformanceViewModel()

    const data = [
        { year: 2010, count: 10 },
        { year: 2011, count: 20 },
        { year: 2012, count: 15 },
        { year: 2013, count: 25 },
        { year: 2014, count: 22 },
        { year: 2015, count: 30 },
        { year: 2016, count: 28 },
    ];

    const timeLabels = ["00:00", "00:02", "00:04", "00:06", "00:08", "00:10"];

    const chart1Counts = [10, 14, 9, 20, 12, 17];

    const chart2Counts = [7, 11, 8, 15, 10, 13];

    const chart3Durations = chart1Counts.map(count => +(100 / count).toFixed(2)); // inverse relation

    const chart4Durations = chart2Counts.map(count => +(120 / count).toFixed(2)); // inverse relation

    const chartData1 = {
        header: "Workflow Open",
        labels: timeLabels,
        datasets: [
            {
                label: "จำนวนที่เข้ามา A",
                data: chart1Counts,
                backgroundColor: "rgba(75,192,192,0.6)",
                borderColor: "rgba(75,192,192,1)",
                borderWidth: 1
            }
        ]
    };

    const chartData2 = {
        header: "Workflow Call back",
        labels: timeLabels,
        datasets: [
            {
                label: "จำนวนที่เข้ามา B",
                data: chart2Counts,
                backgroundColor: "#f39c12",
                borderColor: "#e67e22",
                borderWidth: 1
            }
        ]
    };

    const chartData3 = {
        header: "Workflow Create Time",
        labels: timeLabels,
        datasets: [
            {
                label: "เวลาเฉลี่ย A (ms)",
                data: chart3Durations,
                backgroundColor: "#8e44ad",
                borderColor: "#9b59b6",
                borderWidth: 1
            }
        ]
    };

    const chartData4 = {
        header: "Workflow Call back Time",
        labels: timeLabels,
        datasets: [
            {
                label: "เวลาเฉลี่ย B (ms)",
                data: chart4Durations,
                backgroundColor: "#2ecc71",
                borderColor: "#27ae60",
                borderWidth: 1
            }
        ]
    };

    const [chartData, setChartData] = useState<SingleChartData[]>([chartData1,
        chartData2,
        chartData3,
        chartData4])

    return (
        <Container fluid>
            <Row>
                <Col className="import-export-actions">
                    <div className="trapezoid-head w-[250px]">
                        <span>Workflow Performance Search</span>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="mat-box">
                        <div className="trapezoid trapezoid-purple inline-block w-[200px]">
                            <span>
                                <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                ></i>
                                Search menu
                            </span>
                        </div>

                        <div className="mat-box mb-5 rounded bg-white p-3 shadow">
                            <Row>
                                <Col>
                                    <div className="mt-2">
                                        <Row className="gy-3">
                                            <Col
                                                sm={6}
                                            >
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="formBasicEmail"
                                                >
                                                    <Form.Label>
                                                        Company Name :
                                                    </Form.Label>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <input
                                                            type="checkbox"
                                                        // checked={
                                                        //     selectdAllCompany
                                                        // }
                                                        // onChange={e => {
                                                        //     e.persist();
                                                        //     setSelectdAllCompany(
                                                        //         prev =>
                                                        //             !prev
                                                        //     );
                                                        //     handleSearchInputChange(
                                                        //         'sid',
                                                        //         ''
                                                        //     );
                                                        // }}
                                                        />
                                                        <span className="ms-2">
                                                            เลือกทั้งหมด
                                                        </span>
                                                    </div>
                                                    <div
                                                        style={{ zIndex: 2000 }}
                                                    >
                                                        <CreatableSelect
                                                            isMulti
                                                            isClearable
                                                            // isDisabled={
                                                            //     selectdAllCompany
                                                            // }
                                                            options={
                                                                companyMaster
                                                            }
                                                            value={
                                                                selectedCompany
                                                            }
                                                            // onChange={
                                                            //     handleSelectCompany
                                                            // }
                                                            styles={
                                                                customStyles
                                                            }
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                                className="d-flex align-items-end justify-center"
                                            >
                                                <div className="w-100 h-[38px] mb-3 flex space-x-4 text-center">
                                                    <Button
                                                        variant="outline-info"
                                                        size="sm"
                                                        className="w-full sm:w-auto"
                                                    // onClick={handleSearch}
                                                    >
                                                        <div className="flex items-center">
                                                            <FaSearch /> Search
                                                        </div>
                                                    </Button>
                                                    <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        className="w-full sm:w-auto"
                                                    // onClick={ExportExcel}
                                                    >
                                                        <div className="flex items-center">
                                                            <FaPlusCircle />{' '}
                                                            &nbsp;Export Excel
                                                        </div>
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="gy-3">
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                            >
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="formBasicEmail"
                                                >
                                                    <Form.Label>
                                                        Date From :{' '}
                                                        <BsCalendar2Date />
                                                    </Form.Label>
                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="w-100"
                                                        customInput={
                                                            <Form.Control className="menu-form custom-datepicker" />
                                                        }
                                                    // selected={parseDateFromYYYYMMDD(
                                                    //     searchInputs.sdate
                                                    // )}
                                                    // dateFormat="dd/MM/yyyy"
                                                    // onChange={date => {
                                                    //     handleSearchInputChange(
                                                    //         'sdate',
                                                    //         String(
                                                    //             convertToYYYYMMDD(
                                                    //                 date?.toISOString()!
                                                    //             )
                                                    //         ).substring(
                                                    //             0,
                                                    //             8
                                                    //         )
                                                    //     );
                                                    // }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                            >
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="formBasicEmail"
                                                >
                                                    <Form.Label>
                                                        Date To :{' '}
                                                        <BsCalendar2Date />
                                                    </Form.Label>
                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="w-100"
                                                        customInput={
                                                            <Form.Control className="menu-form custom-datepicker" />
                                                        }
                                                    // selected={parseDateFromYYYYMMDD(
                                                    //     searchInputs.edate
                                                    // )}
                                                    // dateFormat="dd/MM/yyyy"
                                                    // onChange={date => {
                                                    //     handleSearchInputChange(
                                                    //         'edate',
                                                    //         String(
                                                    //             convertToYYYYMMDD(
                                                    //                 date?.toISOString()!
                                                    //             )
                                                    //         ).substring(
                                                    //             0,
                                                    //             8
                                                    //         )
                                                    //     );
                                                    // }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="grid grid-cols-2 gap-4 p-4">
                        {chartData!.map((data, i) => (
                            <div key={i} className="w-full h-[300px]">
                                <Bar
                                    data={data}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            title: {
                                                display: true,
                                                text: data.header
                                            },
                                            legend: {
                                                display: false
                                            }
                                        }
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}